import {initHeroVideo} from "../../utils/hero-video.js";

/**
 * Inner page hero (About us, …): background video loops muted, plays only while in view.
 */
export const pageHero = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.page-hero').forEach((section) => {
            const video = section.querySelector('.page-hero__video');
            if (video) initHeroVideo(section, video);
        });

        resolve();
    });
};
